// @ts-nocheck
import { useRef } from "react";

//scss
import "./style.scss";

//assets
import { SvgCross } from "assets/icons/js/SvgCross";
import { SvgVeg } from "assets/icons/js/SvgVeg";
import { SvgNonVeg } from "assets/icons/js/SvgNonVeg";
import { SvgBBQ } from "assets/icons/js/SvgBBQ";

//components
import Modal from "components/LoginAndRegister/Modal";
import { useOnClickOutside } from "customHooks/useOnClickOutside";

export const AllMeals = ({ open, setOpen, listingList }: any) => {
	const popupRef = useRef(null);

	useOnClickOutside(popupRef, () => setOpen(false));

	const listingID = listingList?.ID;

	let toApplyHotFix = false;

	if (
		listingID === "7nyAhT6QOwB1crdm" ||
		listingID === "md6r0FuebKyXs8uC" ||
		listingID === "uDBLOg3AlYwUaLoT"
	) {
		toApplyHotFix = true;
	}

	return (
		<div className="meals__wrapper">
			<Modal shouldShow={open} onClose={() => setOpen(false)}>
				<div className="meals" ref={popupRef}>
					<div className="meal__head">
						<h3>Meals Preferences</h3>
						<SvgCross className="meals__cross" onClick={() => setOpen(false)} />
					</div>
					<div className="meals__body">
						{/* VEG */}
						{listingList?.meal_charges_adult_allmeals ||
						listingList?.meal_charges_children_allmeals ||
						listingList?.meal_charges_adult ||
						listingList?.meal_charges_children ? (
							<div className="meals__body-content-container">
								<div className="meals__body-heading-container veg-green">
									<SvgVeg />
									<p className="meals__body-heading">Veg</p>
								</div>
								{listingList?.meal_charges_adult_allmeals ||
								listingList?.meal_charges_children_allmeals ? (
									<>
										<h4 className="meals__body-sub-heading">
											{[
												"xKrFmWI9INr8OUTo",
												"s5BTeCcQcvr6thld",
												"h7RoH9qCXJcL88xj",
												"7BCI2TUSSFmR3iZP",
												"iLIql69vyblULH4r",
												"lU8CMLfiaElR57YM",
												"V5wWlgl0FPtsBJ3a",
											].includes(listingList?.id)
												? "Breakfast & Dinner"
												: "All Meals"}{" "}
										</h4>
										{listingList?.meal_charges_adult_allmeals ? (
											<div className="meals__body-content-wrapper">
												<div className="meals__body-content-wrapper-row">
													<p className="meals__body-content-para-normal">
														Adults
													</p>
													<p className="meals__body-content-para-background">
														12+ YEARS
													</p>
												</div>
												<div className="meals__body-content-wrapper-row item-down">
													<p className="meals__body-content-para-bold">
														₹ {listingList?.meal_charges_adult_allmeals}
													</p>
													<p className="meals__body-content-para-small">
														+GST (per guest/day)
													</p>
												</div>
											</div>
										) : null}
										{listingList?.meal_charges_children_allmeals ? (
											<div className="meals__body-content-wrapper">
												<div className="meals__body-content-wrapper-row">
													<p className="meals__body-content-para-normal">
														Children
													</p>
													<p className="meals__body-content-para-background">
														6-12 YEARS
													</p>
												</div>
												<div className="meals__body-content-wrapper-row item-down">
													<p className="meals__body-content-para-bold">
														₹ {listingList?.meal_charges_children_allmeals}
													</p>
													<p className="meals__body-content-para-small">
														+GST (per guest/day)
													</p>
												</div>
											</div>
										) : null}
									</>
								) : null}

								{listingList?.meal_charges_adult ||
								listingList?.meal_charges_children ? (
									<>
										<h4 className="meals__body-sub-heading">
											{toApplyHotFix
												? "Breakfast + Dinner"
												: "Breakfast + 1 meal"}
										</h4>
										{listingList?.meal_charges_adult ? (
											<div className="meals__body-content-wrapper">
												<div className="meals__body-content-wrapper-row">
													<p className="meals__body-content-para-normal">
														Adults
													</p>
													<p className="meals__body-content-para-background">
														12+ YEARS
													</p>
												</div>
												<div className="meals__body-content-wrapper-row item-down">
													<p className="meals__body-content-para-bold">
														₹ {listingList?.meal_charges_adult}
													</p>
													<p className="meals__body-content-para-small">
														+GST (per guest/day)
													</p>
												</div>
											</div>
										) : null}

										{listingList?.meal_charges_children ? (
											<div className="meals__body-content-wrapper">
												<div className="meals__body-content-wrapper-row">
													<p className="meals__body-content-para-normal">
														Children
													</p>
													<p className="meals__body-content-para-background">
														6-12 YEARS
													</p>
												</div>
												<div className="meals__body-content-wrapper-row item-down">
													<p className="meals__body-content-para-bold">
														₹ {listingList?.meal_charges_children}
													</p>
													<p className="meals__body-content-para-small">
														+GST (per guest/day)
													</p>
												</div>
											</div>
										) : null}
									</>
								) : null}
							</div>
						) : null}

						{/* NON VEG */}
						{listingList?.meal_charges_adult_allmeals_NV ||
						listingList?.meal_charges_children_allmeals_nv ||
						listingList?.meal_charges_adult_nv ||
						listingList?.meal_charges_children_nv ? (
							<div className="meals__body-content-container">
								<div className="meals__body-heading-container non-veg-red">
									<SvgNonVeg />
									<p className="meals__body-heading">Non Veg</p>
								</div>
								{listingList?.meal_charges_adult_allmeals_NV ||
								listingList?.meal_charges_children_allmeals_nv ? (
									<>
										<h4 className="meals__body-sub-heading">
											{[
												"xKrFmWI9INr8OUTo",
												"s5BTeCcQcvr6thld",
												"h7RoH9qCXJcL88xj",
												"7BCI2TUSSFmR3iZP",
												"iLIql69vyblULH4r",
												"lU8CMLfiaElR57YM",
												"V5wWlgl0FPtsBJ3a",
											].includes(listingList?.id)
												? "Breakfast & Dinner"
												: "All Meals"}{" "}
										</h4>
										<div className="meals__body-content-wrapper">
											<div className="meals__body-content-wrapper-row">
												<p className="meals__body-content-para-normal">
													Adults
												</p>
												<p className="meals__body-content-para-background">
													12+ YEARS
												</p>
											</div>
											<div className="meals__body-content-wrapper-row item-down">
												<p className="meals__body-content-para-bold">
													₹ {listingList?.meal_charges_adult_allmeals_NV}
												</p>
												<p className="meals__body-content-para-small">
													+GST (per guest/day)
												</p>
											</div>
										</div>

										<div className="meals__body-content-wrapper">
											<div className="meals__body-content-wrapper-row">
												<p className="meals__body-content-para-normal">
													Children
												</p>
												<p className="meals__body-content-para-background">
													6-12 YEARS
												</p>
											</div>
											<div className="meals__body-content-wrapper-row item-down">
												<p className="meals__body-content-para-bold">
													₹ {listingList?.meal_charges_children_allmeals_nv}
												</p>
												<p className="meals__body-content-para-small">
													+GST (per guest/day)
												</p>
											</div>
										</div>
									</>
								) : null}

								{listingList?.meal_charges_adult_nv ||
								listingList?.meal_charges_children_nv ? (
									<>
										<h4 className="meals__body-sub-heading">
											{toApplyHotFix
												? "Breakfast + Dinner"
												: "Breakfast + 1 meal"}
										</h4>
										<div className="meals__body-content-wrapper">
											<div className="meals__body-content-wrapper-row">
												<p className="meals__body-content-para-normal">
													Adults
												</p>
												<p className="meals__body-content-para-background">
													12+ YEARS
												</p>
											</div>
											<div className="meals__body-content-wrapper-row item-down">
												<p className="meals__body-content-para-bold">
													₹ {listingList?.meal_charges_adult_nv}
												</p>
												<p className="meals__body-content-para-small">
													+GST (per guest/day)
												</p>
											</div>
										</div>

										<div className="meals__body-content-wrapper">
											<div className="meals__body-content-wrapper-row">
												<p className="meals__body-content-para-normal">
													Children
												</p>
												<p className="meals__body-content-para-background">
													6-12 YEARS
												</p>
											</div>
											<div className="meals__body-content-wrapper-row item-down">
												<p className="meals__body-content-para-bold">
													₹ {listingList?.meal_charges_children_nv}
												</p>
												<p className="meals__body-content-para-small">
													+GST (per guest/day)
												</p>
											</div>
										</div>
									</>
								) : null}
							</div>
						) : null}

						{/* BARBEQUE */}
						{listingList?.barbeque_veg || listingList?.barbeque_nonveg ? (
							<div className="meals__body-content-container">
								<div className="meals__body-heading-container barbeque-orange">
									<SvgBBQ />
									<p className="meals__body-heading">Barbeque</p>
								</div>

								{listingList?.barbeque_veg ? (
									<div className="meals__body-content-wrapper">
										<div className="meals__body-content-wrapper-row">
											<p className="meals__body-content-para-normal">
												<SvgVeg />
												Veg
											</p>
										</div>
										<div className="meals__body-content-wrapper-row item-down">
											<p className="meals__body-content-para-bold">
												₹ {listingList?.barbeque_veg}
											</p>
											<p className="meals__body-content-para-small">
												+GST (per guest/day)
											</p>
										</div>
									</div>
								) : null}

								{listingList?.barbeque_nonveg ? (
									<div className="meals__body-content-wrapper">
										<div className="meals__body-content-wrapper-row">
											<p className="meals__body-content-para-normal">
												<SvgNonVeg /> Non Veg
											</p>
										</div>
										<div className="meals__body-content-wrapper-row item-down">
											<p className="meals__body-content-para-bold">
												₹ {listingList?.barbeque_nonveg}
											</p>
											<p className="meals__body-content-para-small">
												+GST (per guest/day)
											</p>
										</div>
									</div>
								) : null}
							</div>
						) : null}

						{/* NOTE */}
						{/* <div className="meal__body-note-container">
							<p>
								<strong>Notes:</strong> Please leave this section blank if
								you didn’t avail our meal services.
							</p>
						</div> */}
					</div>
				</div>
			</Modal>
		</div>
	);
};
